import { NEWRELIC_CONFIG } from '../scripts/app-configs/constants'

enum NewrelicEvent {
  ROUTE_CHANGE = 'VueRouteChange',
}

export function trackNewrelicRouteChange(fromPath: string, toPath: string) {
  sendNewrelicPageAction(NewrelicEvent.ROUTE_CHANGE, { from: fromPath, to: toPath })
}

export function trackNewrelicJSError(err: unknown, args: object) {
  sendNewrelicError(err, args)
}

export function startNewrelicScript() {
  window.CONFIG = {
    ...window.CONFIG,
    ...NEWRELIC_CONFIG,
  }
  const newRelicScript = document.createElement('script')
  
  newRelicScript.src = '/newrelic.next.js'
  document.head.appendChild(newRelicScript)
}

function sendNewrelicPageAction(eventType: NewrelicEvent, args: object) {
  if (window.newrelic) {
    window.newrelic.addPageAction?.(eventType, args)
  }
}

function sendNewrelicError(error: unknown, args: object) {
  if (window.newrelic) {
    window.newrelic.noticeError(error, args)
  }
}
